import ApplicationException from '~/modules/Exceptions/Application/ApplicationException'
import { Trophy } from '~/modules/Trophies/Domain/Trophy'

export default class ApiTrophyResponseTranslatorException extends ApplicationException {
  public static trophyDoesNotHaveIdId = 'api_trophy_response_translator_trophy_does_not_have_id'

  public static trophyDoesNotHaveId (trophy: Trophy): ApiTrophyResponseTranslatorException {
    return new ApiTrophyResponseTranslatorException(
      `Trophy with tokenId ${trophy.tokenId} does not have an ID`,
      this.trophyDoesNotHaveIdId
    )
  }
}
